import AbstractScene from './AbstractScene.js';
import eventsCenter from '../sydo/prefab/EventCenter.js'
import { Colors } from '../consts/Colors.js';
import Button from '../prefabs/buttons/Button.js';
import { tags } from '../consts/Tags.js';
import { Fonts } from '../consts/Fonts.js';

export default class UI extends AbstractScene {

    constructor() {
        super({
            key: "UI"
        })
    }
    init(data) {
    }

    preload() {
        this._preload();

        eventsCenter.on('startgame', () => {this.startPopUp()})
        eventsCenter.on('endgame', () => {this.time.addEvent({delay: 3000, callback: () => {this.endPopUp()}})})
        eventsCenter.on('showtitle', () => {this.showTitle()})
        eventsCenter.on('hidetitle', () => {this.hideTitle()})

        this.config = this.cache.json.get('config')
        this.titleGroup = this.add.group()

    }

    create(){
        this.addTitle()
        this.hideTitle()
    }

    pauseScene(){
        // Pause la scene
        var sceneRunning = this.game.data.sceneRunning
        this.scene.pause(sceneRunning);
    }

    restartScene(){
        // Restart la scene
        var sceneRunning = this.game.data.sceneRunning
        this.scene.wake(sceneRunning);
    }

    addTitle(){

        var logoABC = this.add.sprite(62, 90, 'logoMQDE').setOrigin(0, 0.5)
        logoABC.setScale(0.8)
        this.titleGroup.add(logoABC)
        logoABC.setInteractive({useHandCursor:true})
        logoABC.on('pointerup', () => {
            window.open("https://www.mesquestionsdentrepreneur.fr/",'_blank');
        })

        // Ajout titre
        var X = logoABC.x + logoABC.width + 15
        var Y = logoABC.y + logoABC.height /2
        console.log(Y)
        var title = this.add.rexTagText(X, 125, this.config.titre_video, {
            fontSize: "44px",
            fontFamily: Fonts.MassiliaBold,
            fontStyle: 'bold',
            backgroundColor: "transparent",
            color: Colors.Text.Purple
        })
        title.setOrigin(0, 1)
        this.titleGroup.add(title)

        var Xline = logoABC.x - logoABC.width /2
        var line = this.add.rectangle(Xline, Y + 10, this.width - Xline*2, 5, Colors.Elmt.Purple)
        line.setOrigin(0)
        this.titleGroup.add(line)

    }

    showTitle(){
        this.titleGroup.getChildren().forEach(elmt => {
            elmt.setAlpha(1)
        })
    }

    hideTitle(){
        this.titleGroup.getChildren().forEach(elmt => {
            elmt.setAlpha(0)
        })
    }
}